var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"x-scroll"},[_c('ul',{staticClass:"dots"},_vm._l((_vm.steps),function(title,index){return _c('li',{key:index,class:{fulfilled: _vm.step-1 > index, current: _vm.step-1 == index}},[_vm._v(_vm._s(title))])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cd59fc8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ProgressDots.vue
// module id = bmT6
// module chunks = 1